import Typography from '@/common/Typography'
import useMediaQuery from '@/hooks/useMediaQuery'
import EventCard from './EventCard'
import InfiniteScroll, { InfiniteScrollResult } from '@/common/InfiniteScroll'
import { useGetEvents } from '@/store/eventStore'
import ApiState from '@/common/ApiState'
import EmptyScreen from '../EmptyScreen'
import { Event, Status } from '@/apis/eventApis'

type Props = {
  search: string
  dates: [string, string]
  filter: Status | ''
}
const CreatedEvents = (props: Props) => {
  const isMobile = useMediaQuery('(max-width: 640px)')
  const isSearching = () => {
    return props.dates[0] || props.search || props.filter
  }
  return (
    <article className='flex flex-col w-full flex-1 gap-5'>
      <Typography as='h2' heading={isMobile ? '2xs' : 'sm'}>
        Created Events
      </Typography>
      <InfiniteScroll
        data={{
          query: props.search,
          start: props.dates[0] ? props.dates[0].split('T')[0] : undefined,
          end: props.dates[1] ? props.dates[1].split('T')[0] : undefined,
          created: true,
          status: props.filter,
        }}
        getInfiniteData={useGetEvents}
      >
        {({ isInitialLoad, allPageData }: InfiniteScrollResult) => (
          <ApiState
            className='w-full'
            isLoading={isInitialLoad}
            isEmpty={allPageData?.length === 0}
            emptyComponent={
              <EmptyScreen
                title={
                  isSearching()
                    ? 'No events match your search criteria'
                    : "You haven't created events yet"
                }
                subText={
                  isSearching()
                    ? 'Change your search criteria'
                    : 'You have no event created yet'
                }
              />
            }
          >
            <ul className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 content-stretch'>
              {allPageData.map((event: Event) => (
                <EventCard key={event.id} event={event} />
              ))}
            </ul>
          </ApiState>
        )}
      </InfiniteScroll>
    </article>
  )
}

export default CreatedEvents
